<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="6" cy="8" r="5.25" stroke="black" stroke-width="1.5"/>
    <circle cx="10" cy="8" r="5.25" stroke="black" stroke-width="1.5"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconCompareEyes'
}
</script>
